
const url = require('url');

const Q = require('q');
const _ = require('lodash');

const config = require('config');

const Host = require('server/js/lib/host.js');

import methods from './methods';


class MyHost extends Host {
	constructor (options, server) {
		super({
			methods,
		}, server);
	}

	_beforeAjax () {
		return Q.all([
			Host.prototype._beforeAjax.apply(this, arguments),
			config.cms.domains.get(),
		])
			.spread(function (options, domains) {
				const ajaxHost = (() => domains['corp.rgs.ru'])();

				const optionsUrl = url.parse(options.url);

				const ajaxUrl = _.extend(
					{},
					_.pick(optionsUrl, 'pathname', 'search'),
					{
						protocol: 'https',
						host: ajaxHost,
					}
				);

				return _.defaultsDeep({
					url: url.format(ajaxUrl),
					credentials: 'include',
				}, options);
			});
	}
}

module.exports = MyHost;

